/* AIMEA PRELANDER SAFE SCRIPT
   - never crashes theme
   - runs only if prelander IDs exist
*/
(function () {
  try {
    // Run only on pages that contain the prelander
    function exists(id) { return !!document.getElementById(id); }
    function hasPrelander() {
      return exists("adv-timer") || exists("adv-timer2") || exists("adv-timer3") || exists("adv-timerSticky") ||
             exists("adv-offer-from") || exists("adv-offer-to");
    }

    function pad(n) { return String(n).padStart(2, "0"); }

    function endOfTodayTs() {
      var now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
    }

    function tickTimers() {
      var end = endOfTodayTs();
      var diff = Math.max(0, end - Date.now());

      var h = Math.floor(diff / 3600000);
      diff -= h * 3600000;
      var m = Math.floor(diff / 60000);
      diff -= m * 60000;
      var s = Math.floor(diff / 1000);

      var txt = pad(h) + ":" + pad(m) + ":" + pad(s);
      var ids = ["adv-timer", "adv-timer2", "adv-timer3", "adv-timerSticky"];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (el) el.textContent = txt;
      }
    }

    var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    function ordinal(n) {
      var v = n % 100;
      if (v >= 11 && v <= 13) return n + "th";
      switch (n % 10) {
        case 1: return n + "st";
        case 2: return n + "nd";
        case 3: return n + "rd";
        default: return n + "th";
      }
    }
    function formatDate(d) {
      return ordinal(d.getDate()) + " of " + months[d.getMonth()];
    }

    function setOfferWindow() {
      var today = new Date();
      var from = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6);
      var to = new Date(today.getFullYear(), today.getMonth(), today.getDate());

      var fromText = formatDate(from);
      var toText = formatDate(to);

      var fromEl = document.getElementById("adv-offer-from");
      var toEl = document.getElementById("adv-offer-to");
      if (fromEl) fromEl.textContent = fromText;
      if (toEl) toEl.textContent = toText;

      var validText = "Offer valid " + fromText + " – " + toText;

      // Update any element whose id starts with adv-valid-
      var all = document.querySelectorAll("[id^='adv-valid-']");
      for (var i = 0; i < all.length; i++) {
        all[i].textContent = validText;
      }

      var ed = document.getElementById("adv-editorial-date");
      if (ed) ed.textContent = months[today.getMonth()] + " " + today.getDate() + ", " + today.getFullYear();
    }

    function stockBar() {
      var total = 200;
      var claimedEl = document.getElementById("adv-claimed");
      var leftEl = document.getElementById("adv-left");
      var bar = document.getElementById("adv-barFill");
      if (!claimedEl || !leftEl || !bar) return;

      var claimed = Number(claimedEl.textContent || 0);
      if (!isFinite(claimed)) claimed = 0;
      claimed = Math.max(0, Math.min(total, claimed));
      var left = Math.max(0, total - claimed);

      leftEl.textContent = String(left);
      bar.style.width = Math.round((claimed / total) * 100) + "%";
    }

    function start() {
      if (!hasPrelander()) return; // do nothing on other pages
      setOfferWindow();
      stockBar();
      tickTimers();
      if (!window.__ADV_SAFE_INTERVAL__) {
        window.__ADV_SAFE_INTERVAL__ = setInterval(tickTimers, 1000);
      }
    }

    // Defer already waits, but Shopify can inject content late -> retry a few times safely
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      start();
      if (hasPrelander() || tries > 80) clearInterval(t);
    }, 250);

    // Also run once on load
    window.addEventListener("load", function () { start(); }, { once: true });

  } catch (e) {
    // Never crash the theme
    console.warn("adv-prelander.js error (ignored):", e);
  }
})();

